import React from 'react';
import { motion } from 'framer-motion';
import { skillsData } from '../data/skills';
import styles from '../styles/Skills.module.css';

const Skills = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  const tagVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  return (
    <section className={styles.skills} id="skills">
      <div className={styles.skills__container}>
        <motion.h2
          className={styles.skills__heading}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {skillsData.heading}
        </motion.h2>

        <motion.div
           className={styles.skills__grid}
           variants={containerVariants}
           initial="hidden"
           whileInView="visible"
           viewport={{ once: true, margin: "-50px" }}
        >
          {skillsData.categories.map((category, index) => (
            <motion.div 
              key={index} 
              className={styles.skills__category} 
              variants={itemVariants}
            >
              <h3 className={styles.skills__category_title}>{category.title}</h3>
              <div className={styles.skills__tags}>
                {category.skills.map((skill, idx) => (
                  <motion.span
                    key={idx}
                    className={styles.skills__tag}
                    variants={tagVariants}
                    whileHover={{ scale: 1.05, y: -2 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  >
                    <skill.icon className={styles.skills__icon} />
                    {skill.name}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
